import React from "react";
import { Form, Row, Col } from "react-bootstrap";
import WhiteButton from "./../../../../../components/common_components/common_button/WhiteButton";
import "./UpdateBankDetails.css";
import CommonBreadcrumb from './../../../../common_components/breadcrumb/CommonBreadcrumb';
import { useNavigate } from 'react-router-dom';

const UpdateBankDetails = () => {
    const navigate=useNavigate()
      const breadcrumbItems = [
    { label: "Profile", link: "/profile" },
    { label: "Wallet & Earnings" ,link:"/wallet&earnings"},
    { label: "Update Bank Details"  },
  ];
  return (
    <section className="bank-update-wrapper">
           <CommonBreadcrumb items={breadcrumbItems} />
      <div className="bank-update-card">
        <Form>

          <Form.Group className="mb-3">
            <Form.Label className="bank-label">
              Account Holder Name
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="eg. sarah jamdar"
              className="bank-input"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label className="bank-label">
              Bank Name
            </Form.Label>
            <Form.Select className="bank-input">
              <option value="">eg. State Bank of India</option>
              <option>State Bank of India</option>
              <option>HDFC Bank</option>
              <option>ICICI Bank</option>
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label className="bank-label">
              Account Number
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="eg. 123456789012"
              className="bank-input"
            />
          </Form.Group>

          <Row className="mb-3">
            <Col md={6}>
              <Form.Group>
                <Form.Label className="bank-label">
                  IFSC Code
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="eg. SBIN0000456"
                  className="bank-input"
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group>
                <Form.Label className="bank-label">
                  UPI ID (optional)
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="eg. Rahulsharma@Sbi"
                  className="bank-input"
                />
              </Form.Group>
            </Col>
          </Row>

          <p className="bank-warning">
            Ensure bank details are correct to avoid Pay out failure.
          </p>

          <div className="bank-btn-wrapper">
            <WhiteButton
              title="Update Bank Details"
              bg="#010E1E"
              color="#f35f37"
              hoverBg="#010E1E"
              hoverColor="#f35f37"
               onClick={() => navigate("/bank-details-updated")}
            />
          </div>

        </Form>
      </div>
    </section>
  );
};

export default UpdateBankDetails;